(function () {
  var cache = {};
  var shopPriceByProduct = {};
  var shopPriceByVariant = {};
  var rememberTimer = null;
  var APPLY_FIXED = 0;
  var DECREASE_FIXED = 1;
  var DECREASE_PERCENTAGE = 2;
  var ready = false;
  var timer = null;

  function labelFor(moneyHtml) {
    var tpl =
      (window._edPriceFrom && window._edPriceFrom.label) ||
      'From {{ price }}';
    return tpl
      .replace(/\{\{\s*price\s*\}\}/g, moneyHtml)
      .replace('@@PRICE@@', moneyHtml);
  }

  function labelForRange(minMoney, maxMoney) {
    var tpl =
      (window._edPriceFrom && window._edPriceFrom.rangeLabel) ||
      'From {{ minimum }} to {{ maximum }}';
    return tpl
      .replace(/\{\{\s*minimum\s*\}\}/g, minMoney)
      .replace(/\{\{\s*maximum\s*\}\}/g, maxMoney)
      .replace('@@MIN@@', minMoney)
      .replace('@@MAX@@', maxMoney);
  }

  function formatMoney(cents) {
    if (window.BSS_B2B && typeof window.BSS_B2B.formatMoney === 'function') {
      return window.BSS_B2B.formatMoney(cents);
    }
    var amount = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return amount + ' DKK';
  }

  function flattenRules(list) {
    var out = [];
    if (!Array.isArray(list)) return out;
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (Array.isArray(item)) {
        out = out.concat(flattenRules(item));
      } else if (item && (item.id != null || item.dt != null || item.qty_table)) {
        out.push(item);
      }
    }
    return out;
  }

  function getRules() {
    try {
      if (window.BSS_B2B && Array.isArray(window.BSS_B2B.qbRules)) {
        var rootRules = flattenRules(window.BSS_B2B.qbRules);
        if (rootRules.length) return rootRules;
      }
      if (window.BSS_B2B && window.BSS_B2B.qb && window.BSS_B2B.qb.utils && window.BSS_B2B.qb.utils.common) {
        return flattenRules(window.BSS_B2B.qb.utils.common.listQbRule || []);
      }
      if (window.BSS_B2B && window.BSS_B2B.qb && Array.isArray(window.BSS_B2B.qb.qbRules)) {
        return flattenRules(window.BSS_B2B.qb.qbRules);
      }
    } catch (e) {}
    return [];
  }

  function normId(value) {
    if (value == null || value === '') return '';
    var text = String(value);
    var gid = text.match(/(\d+)\s*$/);
    return gid ? gid[1] : text.replace(/\D/g, '') || text;
  }

  function parseIdList(value) {
    if (!value) return [];
    var raw = Array.isArray(value) ? value : String(value).split(',');
    return raw
      .map(function (s) {
        return normId(s);
      })
      .filter(Boolean);
  }

  function parseTagList(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value
        .map(function (tag) {
          return String(tag || '')
            .toLowerCase()
            .trim();
        })
        .filter(Boolean);
    }
    return String(value)
      .split(',')
      .map(function (tag) {
        return tag.toLowerCase().trim();
      })
      .filter(Boolean);
  }

  function toCents(value) {
    if (value == null || value === '') return null;
    var raw = String(value).trim();
    var n = Number(raw.replace(',', '.'));
    if (!isFinite(n) || n <= 0) return null;
    if (raw.indexOf('.') !== -1 || raw.indexOf(',') !== -1) return Math.round(n * 100);
    return Math.round(n);
  }

  function pickLowestCents(found) {
    if (!found.length) return null;
    var max = Math.max.apply(null, found);
    var out = [];
    for (var i = 0; i < found.length; i++) {
      var value = found[i];
      if (value > 0 && max / value >= 80 && max / value <= 125) value = value * 100;
      out.push(value);
    }
    return Math.min.apply(null, out);
  }

  function volumeFixedDkk(productId, variantId) {
    var rule = getAppliedRule(productId, variantId);
    if (!rule || !rule.qty_table) return [];
    var out = [];
    for (var i = 0; i < rule.qty_table.length; i++) {
      var row = rule.qty_table[i];
      var dt = row.discount_type != null ? Number(row.discount_type) : Number(row.dt);
      if (dt !== APPLY_FIXED) continue;
      var dv = Number(String(row.discount_value != null ? row.discount_value : '').replace(',', '.'));
      if (isFinite(dv) && dv > 0) out.push(dv);
    }
    return out;
  }

  function alignCentsToVolume(cents, productId, variantId) {
    if (cents == null || cents <= 0) return cents;
    var tiers = volumeFixedDkk(productId, variantId);
    if (!tiers.length) return cents;
    for (var i = 0; i < tiers.length; i++) {
      if (Math.abs(cents - tiers[i]) < 0.051) return Math.round(tiers[i] * 100);
    }
    var maxTier = Math.max.apply(null, tiers) * 100;
    var minTier = Math.min.apply(null, tiers) * 100;
    if (cents > 0 && maxTier / cents >= 80 && maxTier / cents <= 125) return Math.round(cents * 100);
    if (cents > 0 && minTier / cents >= 80 && minTier / cents <= 125) return Math.round(cents * 100);
    return cents;
  }

  function isVolumeTierAmount(cents, productId, variantId) {
    if (cents == null || cents <= 0) return false;
    var tiers = volumeFixedDkk(productId, variantId);
    if (!tiers.length) return false;
    for (var i = 0; i < tiers.length; i++) {
      var dkk = tiers[i];
      if (Math.abs(cents - dkk) < 0.051) return true;
      if (Math.abs(cents - Math.round(dkk * 100)) < 1) return true;
    }
    return false;
  }

  function queueRememberNotify() {
    if (rememberTimer) return;
    rememberTimer = setTimeout(function () {
      rememberTimer = null;
      clearCache();
      scanDom();
      notifyUpdated();
    }, 50);
  }

  function rememberShopPrice(productId, variantId, value) {
    var cents = toCents(value);
    if (cents == null || cents <= 0) return false;
    cents = alignCentsToVolume(cents, productId, variantId);
    if (cents == null || cents <= 0) return false;
    var pid = normId(productId);
    var vid = normId(variantId);
    var changed = false;
    if (pid && shopPriceByProduct[pid] !== cents) {
      shopPriceByProduct[pid] = cents;
      changed = true;
    }
    if (vid && shopPriceByVariant[vid] !== cents) {
      shopPriceByVariant[vid] = cents;
      changed = true;
    }
    if (changed) {
      clearCache();
      queueRememberNotify();
    }
    return changed;
  }

  function rememberProduct(data) {
    if (!data || typeof data !== 'object') return false;
    var pid = data.id != null ? data.id : data.product_id || data.productId;
    var changed = false;
    if (data.price != null) changed = rememberShopPrice(pid, null, data.price) || changed;
    var variants = data.variants;
    if (Array.isArray(variants)) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant || variant.price == null) continue;
        changed =
          rememberShopPrice(pid, variant.id || variant.variant_id || variant.variantId, variant.price) || changed;
      }
    }
    return changed;
  }

  function customerTags() {
    var raw =
      (window._edCustomer && window._edCustomer.tags) ||
      window.__edCustomerTags ||
      window.__dragonGateCustomerTags ||
      [];
    var tags = parseTagList(raw);
    var company = String(
      (window._edCustomer && window._edCustomer.company) || window.__dragonGateCompanyName || ''
    )
      .toLowerCase()
      .trim();
    if (company && tags.indexOf(company) === -1) tags.push(company);
    return tags;
  }

  function isLoggedIn() {
    if (window._edCustomer && window._edCustomer.loggedIn != null) return !!window._edCustomer.loggedIn;
    return !!(window.__edCustomerTags || window.__dragonGateCustomerTags || (window._edCustomer && window._edCustomer.tags));
  }

  function customerId() {
    var id =
      (window._edCustomer && window._edCustomer.id) ||
      (window.Shopify && Shopify.customer && Shopify.customer.id) ||
      '';
    return String(id || '');
  }

  function tagListMatches(needles, tags) {
    var required = parseTagList(needles);
    if (!required.length) return false;
    for (var i = 0; i < required.length; i++) {
      if (tags.indexOf(required[i]) !== -1) return true;
    }
    return false;
  }

  function idListMatches(needles, id) {
    var needle = normId(id);
    if (!needle) return false;
    return parseIdList(needles).indexOf(needle) !== -1;
  }

  function ruleDateOk(rule) {
    if (!rule) return false;
    var start = rule.start_date || rule.startDate || rule.sd;
    var startTime = rule.start_time || rule.startTime || rule.st;
    var end = rule.end_date || rule.endDate || rule.ed;
    var endTime = rule.end_time || rule.endTime || rule.et;
    var enableEnd = rule.enable_end_date != null ? rule.enable_end_date : rule.eed;
    if (window.BSS_B2B && window.BSS_B2B.utils && typeof window.BSS_B2B.utils.checkDateAndTime === 'function') {
      try {
        return !!window.BSS_B2B.utils.checkDateAndTime({
          start_date: start,
          start_time: startTime,
          end_date: end,
          end_time: endTime,
          enable_end_date: enableEnd,
        });
      } catch (e) {}
    }
    if (!start || !startTime) return true;
    var now = Date.now();
    var startAt = Date.parse(start);
    if (isFinite(startAt) && now < startAt) return false;
    if (enableEnd === 0 || enableEnd === false || enableEnd === '0') return true;
    if (end) {
      var endAt = Date.parse(end);
      if (isFinite(endAt) && now > endAt) return false;
    }
    return true;
  }

  function ruleHasCustomerScope(rule) {
    if (!rule) return false;
    if (Number(rule.apply_to) === 4) return true;
    return parseTagList(rule.customer_tags || rule.customerTags || rule.ct).length > 0;
  }

  function ruleEligible(rule) {
    if (!rule || !ruleDateOk(rule)) return false;
    var tags = customerTags();
    if (tagListMatches(rule.exc_customer_tags || rule.exclude_customer_tags, tags)) return false;
    if (idListMatches(rule.exc_customers || rule.exclude_customers, customerId())) return false;
    var applyTo = rule.apply_to != null && rule.apply_to !== '' ? Number(rule.apply_to) : null;
    var required = parseTagList(rule.customer_tags || rule.customerTags || rule.ct);
    if (applyTo === 4 || required.length) {
      return required.length ? tagListMatches(required, tags) : false;
    }
    if (applyTo === 1 && !isLoggedIn()) return false;
    if (applyTo === 2 || applyTo === 3) {
      return idListMatches(rule.customers || rule.customer_ids || rule.customerIds, customerId());
    }
    return true;
  }

  function ruleMatches(rule, productId, variantId) {
    if (!rule) return false;
    var pids = parseIdList(rule.product_ids || rule.productIds || rule.pi);
    var vids = parseIdList(rule.product_variants || rule.productVariants);
    var pid = normId(productId);
    var vid = normId(variantId);
    if (vids.length && vid && vids.indexOf(vid) !== -1) return true;
    if (pids.length && pid && pids.indexOf(pid) !== -1) return true;
    if (pids.length && vid && pids.indexOf(vid) !== -1) return true;
    if (rule.appliedProductId && normId(rule.appliedProductId) === pid) return true;
    if (rule.appliedVariantId && vid && normId(rule.appliedVariantId) === vid) return true;
    return false;
  }

  function pickBestRule(rules, productId, variantId) {
    var best = null;
    var bestScore = -1;
    for (var r = 0; r < rules.length; r++) {
      var rule = rules[r];
      if (!ruleMatches(rule, productId, variantId)) continue;
      if (!ruleEligible(rule)) continue;
      var score = (ruleHasCustomerScope(rule) ? 100000 : 0) + (Number(rule.priority) || 0);
      if (!best || score > bestScore) {
        best = rule;
        bestScore = score;
      }
    }
    return best;
  }

  function getAppliedRule(productId, variantId) {
    var picked = pickBestRule(getRules(), productId, variantId);
    if (picked) return picked;
    try {
      if (window.BSS_B2B && window.BSS_B2B.storage) {
        if (variantId && window.BSS_B2B.storage.variantStorage) {
          var variant = window.BSS_B2B.storage.variantStorage.get(+variantId);
          if (variant && variant.appliedQB && ruleEligible(variant.appliedQB)) return variant.appliedQB;
        }
        if (productId && window.BSS_B2B.storage.productStorage) {
          var product = window.BSS_B2B.storage.productStorage.get(+productId);
          if (product && product.appliedQB && ruleEligible(product.appliedQB)) return product.appliedQB;
        }
      }
    } catch (e) {}
    return null;
  }

  function pushCents(list, value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      pushCents(list, value.price);
      pushCents(list, value.priceMin);
      pushCents(list, value.price_min);
      pushCents(list, value.compareAt);
      pushCents(list, value.compareAtPrice);
      pushCents(list, value.compare_at);
      pushCents(list, value.compare_at_price);
      pushCents(list, value.variantPrice);
      pushCents(list, value.variantCompareAt);
      return;
    }
    var cents = toCents(value);
    if (cents != null && cents > 0) list.push(cents);
  }

  function shopBaseCents(productId, variantId, hint) {
    var catalog = [];
    var found = [];
    var pid = normId(productId);
    var vid = normId(variantId);
    if (vid && shopPriceByVariant[vid]) catalog.push(shopPriceByVariant[vid]);
    if (pid && shopPriceByProduct[pid]) catalog.push(shopPriceByProduct[pid]);
    pushCents(found, hint);
    try {
      var storedVid = +vid;
      var storedPid = +pid;
      if (storedVid && window.BSS_B2B && window.BSS_B2B.storage && window.BSS_B2B.storage.variantStorage) {
        var v = window.BSS_B2B.storage.variantStorage.get(storedVid);
        if (v) {
          pushCents(found, v.price);
          pushCents(found, v.compare_at_price || v.compareAtPrice || v.compare_at);
        }
      }
      if (storedPid && window.BSS_B2B && window.BSS_B2B.storage && window.BSS_B2B.storage.productStorage) {
        var p = window.BSS_B2B.storage.productStorage.get(storedPid);
        if (p) {
          pushCents(found, p.price);
          pushCents(found, p.compare_at_price || p.compareAtPrice || p.compare_at);
          if (p.currentVariant) {
            pushCents(found, p.currentVariant.price);
            pushCents(
              found,
              p.currentVariant.compare_at_price || p.currentVariant.compareAtPrice
            );
          }
        }
      }
    } catch (e) {}
    var usable = catalog.slice();
    for (var i = 0; i < found.length; i++) {
      if (!isVolumeTierAmount(found[i], productId, variantId)) usable.push(found[i]);
    }
    var picked = pickLowestCents(usable);
    if (picked == null && found.length) {
      var allVolume = true;
      for (var j = 0; j < found.length; j++) {
        if (!isVolumeTierAmount(found[j], productId, variantId)) {
          allVolume = false;
          break;
        }
      }
      var scaled = pickLowestCents(found);
      var rawMax = Math.max.apply(null, found);
      if (allVolume && found.length > 1 && scaled != null && rawMax > scaled && rawMax / scaled < 80) {
        picked = rawMax;
      } else {
        picked = scaled;
      }
    }
    return alignCentsToVolume(picked, productId, variantId);
  }

  function getConfigRules() {
    var raw = window.BSS_B2B && window.BSS_B2B.configData;
    if (!raw) return [];
    if (Array.isArray(raw)) return flattenRules(raw);
    if (typeof raw !== 'object') return [];
    if (raw.rules) return flattenRules(raw.rules);
    if (raw.list) return flattenRules(raw.list);
    if (raw.data) return flattenRules(raw.data);
    if (raw.id != null || raw.dt != null || raw.dv != null) return [raw];
    return flattenRules(Object.keys(raw).map(function (key) {
      return raw[key];
    }));
  }

  function cpProductMatches(rule, productId, variantId) {
    if (!rule) return false;
    var pct =
      rule.product_condition_type != null
        ? Number(rule.product_condition_type)
        : rule.pct != null
          ? Number(rule.pct)
          : null;
    var pid = normId(productId);
    var vid = normId(variantId);
    if (window.BSS_B2B && window.BSS_B2B.utils && typeof window.BSS_B2B.utils.checkProduct === 'function') {
      try {
        return !!window.BSS_B2B.utils.checkProduct(
          {
            product_condition_type: pct,
            product_ids: rule.product_ids || rule.productIds || rule.pi,
            product_collections: rule.product_collections || rule.pc,
            product_tags: rule.product_tags || rule.pt,
            product_variants: rule.product_variants || rule.productVariants || rule.pv,
          },
          {
            id: pid ? +pid : 0,
            currentVariant: { id: vid ? +vid : 0 },
            collections: [],
            tags: [],
          }
        );
      } catch (e) {}
    }
    if (pct === 0) return true;
    var pids = parseIdList(rule.pi || rule.product_ids || rule.productIds);
    var vids = parseIdList(rule.pv || rule.product_variants || rule.productVariants);
    if (pct === 4) return !!(vids.length && vid && vids.indexOf(vid) !== -1);
    return !!(
      pids.length &&
      ((pid && pids.indexOf(pid) !== -1) || (vid && pids.indexOf(vid) !== -1))
    );
  }

  function cpRuleApplies(rule, productId, variantId) {
    if (!rule || !ruleDateOk(rule)) return false;
    var tags = customerTags();
    var at = rule.at != null ? Number(rule.at) : rule.apply_to != null ? Number(rule.apply_to) : null;
    var required = parseTagList(rule.ct || rule.customer_tags || rule.customerTags);
    if (at === 4 || required.length) {
      if (!required.length || !tagListMatches(required, tags)) return false;
    } else if (at === 2 || at === 3) {
      if (!idListMatches(rule.ci || rule.customers || rule.customer_ids, customerId())) return false;
    } else if (at === 1 && !isLoggedIn()) {
      return false;
    }
    return cpProductMatches(rule, productId, variantId);
  }

  function applyCustomDiscount(baseCents, rule) {
    if (baseCents == null || !rule) return null;
    var dt = rule.dt != null ? Number(rule.dt) : Number(rule.discount_type);
    var dv = Number(String(rule.dv != null ? rule.dv : rule.discount_value).replace(',', '.'));
    if (!isFinite(dv)) return null;
    var cents = null;
    if (dt === APPLY_FIXED) cents = Math.round(dv * 100);
    else if (dt === DECREASE_FIXED) cents = Math.round(baseCents - dv * 100);
    else if (dt === DECREASE_PERCENTAGE) cents = Math.round(baseCents * (1 - dv / 100));
    return cents != null && cents > 0 ? cents : null;
  }

  function bssAppliedCustomCents(productId, variantId, baseCents) {
    if (baseCents == null) return null;
    try {
      var vid = +normId(variantId);
      var pid = +normId(productId);
      if (vid && window.BSS_B2B && window.BSS_B2B.storage && window.BSS_B2B.storage.variantStorage) {
        var stored = window.BSS_B2B.storage.variantStorage.get(vid);
        if (stored && stored.bssB2BPriceAfterCP != null) {
          var applied = toCents(stored.bssB2BPriceAfterCP);
          if (applied == null && Number(stored.bssB2BPriceAfterCP) > 0) {
            applied = Math.round(Number(stored.bssB2BPriceAfterCP));
          }
          if (applied != null && applied > 0) return applied;
        }
      }
      var cpUtils =
        window.BSS_B2B && window.BSS_B2B.cp && window.BSS_B2B.cp.utils && window.BSS_B2B.cp.utils.common;
      if (
        cpUtils &&
        typeof cpUtils.getCustomerAppliedRules === 'function' &&
        typeof cpUtils.calculateDiscount === 'function'
      ) {
        var appliedRules = cpUtils.getCustomerAppliedRules() || [];
        for (var i = 0; i < appliedRules.length; i++) {
          var rule = appliedRules[i];
          var matches = false;
          if (typeof cpUtils.checkProduct === 'function') {
            matches = !!cpUtils.checkProduct(rule, {
              id: pid,
              currentVariant: { id: vid },
              collections: [],
              tags: [],
            });
          } else {
            matches = cpProductMatches(rule, productId, variantId);
          }
          if (!matches) continue;
          var dt = Number(rule.discount_type != null ? rule.discount_type : rule.dt);
          var dv = Number(String(rule.discount_value != null ? rule.discount_value : rule.dv).replace(',', '.'));
          var next = cpUtils.calculateDiscount(baseCents, dt, dv);
          if (next != null && isFinite(next) && next > 0) return Math.round(next);
        }
      }
    } catch (e) {}
    return null;
  }

  function customPriceCents(productId, baseCents, variantId) {
    if (baseCents == null) return null;
    var fromBss = bssAppliedCustomCents(productId, variantId, baseCents);
    if (fromBss != null && baseCents != null && baseCents / fromBss >= 80) fromBss = null;
    if (fromBss != null) {
      fromBss = alignCentsToVolume(fromBss, productId, variantId);
      if (fromBss != null) return fromBss;
    }
    var rules = getConfigRules();
    var best = null;
    var bestScore = -1;
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!cpRuleApplies(rule, productId, variantId)) continue;
      var score = (Number(rule.priority) || 0) + 1;
      if (score >= bestScore) {
        best = rule;
        bestScore = score;
      }
    }
    if (!best) return baseCents;
    var next = applyCustomDiscount(baseCents, best);
    return next != null ? next : baseCents;
  }

  function tierPriceCents(row, ruleForCalc, baseCents) {
    if (!row) return null;
    var utils = window.BSS_B2B && window.BSS_B2B.qb && window.BSS_B2B.qb.utils && window.BSS_B2B.qb.utils.common;
    var cents = null;

    if (utils && typeof utils.getDiscountedPriceAndDiscountValue === 'function' && ruleForCalc.price != null) {
      try {
        var info = utils.getDiscountedPriceAndDiscountValue(row, ruleForCalc);
        if (info && info.originDiscountedPrice != null) {
          cents = Math.round(Number(info.originDiscountedPrice));
        }
      } catch (e) {}
    }

    if (cents == null) {
      var rate = 1;
      try {
        rate = Number(window.Shopify.currency.rate) || 1;
      } catch (e2) {}
      var dv = Number(row.discount_value);
      if (isNaN(dv)) return null;
      if (row.discount_type === APPLY_FIXED || row.dt === APPLY_FIXED) {
        cents = Math.round(dv * rate * 100);
      } else if ((row.discount_type === DECREASE_FIXED || row.dt === DECREASE_FIXED) && baseCents != null) {
        cents = Math.round(baseCents - dv * rate * 100);
      } else if ((row.discount_type === DECREASE_PERCENTAGE || row.dt === DECREASE_PERCENTAGE) && baseCents != null) {
        cents = Math.round(baseCents * (1 - dv / 100));
      }
    }

    return cents != null && cents > 0 ? cents : null;
  }

  function tierBoundsCents(rule, baseCents) {
    if (!rule) return { lowest: null, highest: null };
    var table = rule.qty_table || [];
    if (!table.length) return { lowest: null, highest: null };

    var ruleForCalc = rule;
    if (baseCents != null) {
      ruleForCalc = Object.assign({}, rule, { price: baseCents });
    }

    var lowest = null;
    var highest = null;
    for (var i = 0; i < table.length; i++) {
      var cents = tierPriceCents(table[i], ruleForCalc, baseCents);
      if (cents == null) continue;
      if (baseCents != null && cents > baseCents) cents = baseCents;
      if (lowest === null || cents < lowest) lowest = cents;
      if (highest === null || cents > highest) highest = cents;
    }

    return { lowest: lowest, highest: highest };
  }

  function resolveMode(el, explicitMode) {
    if (explicitMode === 'pdp' || explicitMode === 'grid') return explicitMode;
    if (el) {
      var attr = el.getAttribute('data-ed-price-from-mode');
      if (attr === 'pdp' || attr === 'grid') return attr;
      if (el.closest('.page-product, .product__info-wrapper, .featured-product, .product--template')) {
        return 'pdp';
      }
    }
    return 'grid';
  }

  function resolvePriceFrom(productId, variantId, mode, baseHint) {
    var resolvedMode = mode === 'pdp' || mode === 'grid' ? mode : 'grid';
    var key =
      String(productId || '') +
      ':' +
      String(variantId || '') +
      ':' +
      resolvedMode +
      ':' +
      String(baseHint == null ? '' : baseHint);
    if (cache[key]) return cache[key];

    var shopBase = shopBaseCents(productId, variantId, baseHint);
    var customerBase = customPriceCents(productId, shopBase, variantId);
    var rule = getAppliedRule(productId, variantId);
    var lowest = customerBase;
    var highest = customerBase;
    var usedTier = false;

    if (rule) {
      var bounds = tierBoundsCents(rule, customerBase);
      if (bounds.lowest != null) {
        if (customerBase == null || bounds.lowest < customerBase) {
          lowest = bounds.lowest;
          usedTier = true;
        } else {
          lowest = customerBase;
        }
        highest = bounds.highest != null ? bounds.highest : bounds.lowest;
        if (customerBase != null && (highest == null || highest > customerBase)) highest = customerBase;
      }
    }

    if (lowest == null) return null;

    var lowestMoney = formatMoney(lowest);
    var highestMoney = formatMoney(highest != null ? highest : lowest);
    var html = usedTier ? labelFor(lowestMoney) : lowestMoney;

    var result = {
      cents: lowest,
      highestCents: highest,
      money: lowestMoney,
      highestMoney: highestMoney,
      html: html,
      mode: resolvedMode,
      fromRule: usedTier,
      usedTier: usedTier,
    };
    cache[key] = result;
    return result;
  }

  function isPriceGated() {
    return !!(window._edPriceGate && window._edPriceGate.hide);
  }

  function updateElement(el, productId, variantId) {
    if (isPriceGated()) return false;
    if (el.closest('.ed-price--gated') || el.querySelector('.ed-login-price') || el.classList.contains('ed-login-price')) {
      return false;
    }
    var mode = resolveMode(el);
    var baseHint = el.getAttribute('data-ed-base-price');
    var info = resolvePriceFrom(productId, variantId, mode, baseHint);
    if (!info) return false;
    if (
      el.getAttribute('data-ed-price-from-applied') === info.money + '|' + info.mode &&
      el.innerHTML === info.html
    ) {
      return false;
    }
    el.innerHTML = info.html;
    el.setAttribute('data-ed-price-from-applied', info.money + '|' + info.mode);
    el.classList.add('ed-price-from--active');
    // Drawer "You might like" cards: BSS keeps its price wrappers visibility:hidden until it processes them,
    // which it never does inside the drawer upsell. Mark the wrapper once our price is in (2026-10-23).
    var upsellWrap = el.closest('.wbcartupsell') && el.closest('.price');
    if (upsellWrap) upsellWrap.classList.add('ed-price-from--ready');
    el.removeAttribute('bss-b2b-variant-price');
    el.removeAttribute('bss-b2b-product-price');
    return true;
  }

  function scanDom(root) {
    var changed = 0;
    if (isPriceGated()) return changed;
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      '[data-ed-price-from], .price .price-item--regular[bss-b2b-variant-price], .price .price-item--regular[bss-b2b-product-price], .price .price-item--sale[bss-b2b-variant-price], .ed-usf-list-price[data-ed-product-id]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Cart lines are priced by BSS itself; the "You might like" upsell cards inside the drawer are
      // product cards and must use the same resolver as collection cards (2026-10-23).
      if (!el.closest('.wbcartupsell') && el.closest('.cart-item, cart-drawer, .cart-drawer, #CartDrawer, .cart-notification')) continue;
      if (el.closest('.ed-price--gated')) continue;
      var productId =
        el.getAttribute('data-ed-product-id') ||
        el.getAttribute('bss-b2b-product-id') ||
        (el.closest('[bss-b2b-product-id]') &&
          el.closest('[bss-b2b-product-id]').getAttribute('bss-b2b-product-id'));
      var variantId =
        el.getAttribute('data-ed-variant-id') ||
        el.getAttribute('bss-b2b-variant-id') ||
        (el.closest('[bss-b2b-variant-id]') &&
          el.closest('[bss-b2b-variant-id]').getAttribute('bss-b2b-variant-id'));
      if (!productId && !variantId) continue;
      if (updateElement(el, productId, variantId)) changed += 1;
    }
    return changed;
  }

  function clearCache() {
    cache = {};
  }

  function notifyUpdated() {
    try {
      document.dispatchEvent(new CustomEvent('ed:bss-price-from-updated'));
    } catch (e) {}
  }

  window._edBssPriceFrom = {
    get: function (productId, variantId, mode, baseHint) {
      if (isPriceGated()) return null;
      return resolvePriceFrom(productId, variantId, mode, baseHint);
    },
    rememberProduct: rememberProduct,
    rememberShopPrice: rememberShopPrice,
    refresh: function () {
      clearCache();
      scanDom();
      notifyUpdated();
    },
    labelFor: labelFor,
    labelForRange: labelForRange,
    _test: {
      toCents: toCents,
      ruleEligible: ruleEligible,
      pickBestRule: pickBestRule,
      customPriceCents: customPriceCents,
      resolvePriceFrom: resolvePriceFrom,
      customerTags: customerTags,
      shopBaseCents: shopBaseCents,
      pickLowestCents: pickLowestCents,
      alignCentsToVolume: alignCentsToVolume,
      isVolumeTierAmount: isVolumeTierAmount,
      rememberProduct: rememberProduct,
      rememberShopPrice: rememberShopPrice,
      ruleDateOk: ruleDateOk,
      cpProductMatches: cpProductMatches,
      normId: normId,
    },
  };

  function bssReady() {
    if (!window.BSS_B2B) return false;
    if (Array.isArray(window.BSS_B2B.qbRules) && flattenRules(window.BSS_B2B.qbRules).length) return true;
    if (window.BSS_B2B.configData) return true;
    if (window.BSS_B2B.qb && window.BSS_B2B.qb.utils) return true;
    return false;
  }

  function boot() {
    if (!bssReady()) return false;
    ready = true;
    clearCache();
    scanDom();
    notifyUpdated();
    try {
      document.dispatchEvent(new CustomEvent('ed:bss-price-from-ready'));
    } catch (e) {}
    setTimeout(function () {
      scanDom();
      notifyUpdated();
    }, 500);
    setTimeout(function () {
      scanDom();
      notifyUpdated();
    }, 1500);
    setTimeout(function () {
      scanDom();
      notifyUpdated();
    }, 3000);
    return true;
  }

  function schedule() {
    if (timer) return;
    var tries = 0;
    timer = setInterval(function () {
      tries += 1;
      if (boot() || tries > 40) {
        clearInterval(timer);
        timer = null;
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', function () {
    clearCache();
    scanDom();
    notifyUpdated();
  });

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () {
      scanQueued = false;
      if (!ready) return;
      if (scanDom()) notifyUpdated();
    }, 120);
  }

  function isWishlistNode(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    return !!(el && el.closest && el.closest('.ed-wishlist, [data-ed-wishlist]'));
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (!isWishlistNode(records[i].target)) {
        queueScan();
        return;
      }
    }
  });

  try {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } catch (e) {}
})();
